const genericError = new Error();
const defaultProps = Object.getOwnPropertyNames(genericError);

const extractExtraErrorProps = (error: Error) => {
    const uniqueErrorEntries = Object.entries(error).filter(([key]) => !defaultProps.includes(key));
    const errorExtraFields = uniqueErrorEntries.reduce((extraData, [key, val]) => ({...extraData, [key]: val}), {});

    return errorExtraFields;
};

export default extractExtraErrorProps;
